<template>
  <div class="navbar">
    <div class="left">
      <div class="logo"><img src="../../assets/image/logo.png" alt=""></div>
      <div class="shu"></div>
      <div class="welcome">商家后台</div>
    </div>
    <!-- <hamburger id="hamburger-container" class="hamburger-container" @toggleClick="toggleSideBar" /> -->
    <!-- <breadcrumb id="breadcrumb-container" class="breadcrumb-container" v-if="!topNav" /> -->
    <top-nav id="topmenu-container" class="topmenu-container" v-if="topNav" />
    <div class="right-menu">
      <div class="click-active hover-box-color"
        style="width: 64px; height: 64px;line-height: 64px;padding-top:5px; cursor: pointer"
        flex="dir:left main:center cross:center">
        <div @click="opennoticemange()">
          <el-badge :value="value" class="item" :offset="[5, 15]"  :show-zero="false">
            <el-icon size="20">
              <Bell />
            </el-icon>
          </el-badge>
        </div>
        <!-- <div><el-badge :value="value" style="margin-top: -15px; margin-right: 30px"> </el-badge></div> -->
      </div>
      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper hover-box-color c-p" style="line-height: 64px;">
          <span class="user-nickname" style="vertical-align: middle">{{ nickname }}</span>
          <div><el-icon style="vertical-align: middle; height: 20px; margin-left: 5px">
              <CaretBottom />
            </el-icon></div>
        </div>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item @click="logout()">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
    <el-dialog v-model="$store.state.stationStatus" title="站内通知" width="1400">
      <div style="min-height: 600px;overflow-y: scroll;">
        <div class="waitbox">

          <div class="waitbottom">
            <div class="waitli" v-for="(item, index) in $store.state.stationMessage" :key="index">
              <div>
                <div class="waitli_type">
                  <el-badge :is-dot="item.readStatus == 0" class="item"><strong class="stitle">{{ item.title }}</strong>
                  </el-badge>
                  <span style="display: inline-block;margin-left: 8px;font-size: 12px;">{{ $parseTime(item.createTime) }}</span>
                </div>
                <div class="waitli_desc">{{ item.content }}</div>
              </div>
              <div class="buttonlist">
                <el-button type="info" plain v-if="item.readStatus == 0" @click="ignore(item)">忽略</el-button>
                <el-button type="primary" v-if="(item.sort == 9 || item.sort == 11 || item.sort == 12) && !item.adoptStatus"
                  @click="dealthings(item)">去处理</el-button>
                <el-button type="primary" v-if="adoptStatus" @click="showdetail(item)">查看详情</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <!-- 分页组件 -->
          <pagination v-show="$store.state.total > 0" :total="$store.state.total" v-model:page="queryParams.pageNo"
            v-model:limit="queryParams.pageSize" @pagination="getStationMessage" />
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import breadcrumb from '@/components/Breadcrumb/index.vue';
import Hamburger from '@/components/Hamburger/index.vue';
import { getPath } from '@/utils/base.js';
import { getBackGet } from '@/api/home/home.js';
import { getStationMessagePage, updateReadStatus } from '@/api/message/stationmessage.js';

export default {
  components: { breadcrumb, Hamburger },
  computed: {
    ...mapGetters(['nickname']),
  },
  created() {
    this.currentTime = (new Date()).getTime();

    // 循环定时器，不停歇，每过一段时间time，执行一次。
    let that = this
    that.getBack()
    setInterval(function () {
      that.getBack()
    }, 10000)
  },
  data() {
    return {
      topNav: false,
      queryParams: {
        pageNo: 1,
        pageSize: 10,
        type:1
      },
      total: 0,
      value: 0,
      currentTime: 0,
      stationMessage: []
    }
  },
  watch(){

  },
  methods: {
    tips(data) {},
    showdetail(item) {
      let data = item.sort;
      if (data == 1) {//企业认证

      } else if (data == 2) {//人员审核

      } else if (data == 3) {//报价信息
        this.$router.push({ path: '/inquiry/purchaseList', query: { id: item.formId } });
        this.$store.state.stationStatus = false;
      } else if (data == 4) {//采购通过

      } else if (data == 5) {//店铺停用

      } else if (data == 6) {//系统公告

      } else if (data == 7) {//意见反馈
        this.$router.push({ path: '/base/feedback', query: { id: item.formId } })
        // sessionStorage.setItem("dealid",item.formId)
        this.$store.state.stationStatus = false;
      } else if (data == 8) {//企业审核
        this.$router.push({ path: '/audit/companyAuditList' })
      } else if (data == 9) {//订购提醒

      } else if (data == 10) {//企业库认领

      } else if (data == 11) {//询单提醒 

      } else if (data == 12) {//索样提醒

      }
    },
    dealthings(item) {
      this.$store.state.stationStatus=false;
      let data = item.sort;
      if (data == 1) {//企业认证
            this.$router.push({ path: '/audit/companyAuditList' })
      } else if (data == 2) {//人员审核

      } else if (data == 3) {//报价信息
        this.$router.push({ path: '/inquiry/purchaseList', query: { id: item.formId } });
        this.$store.state.stationStatus = false;
      } else if (data == 4) {//采购通过

      } else if (data == 5) {//店铺停用

      } else if (data == 6) {//系统公告

      } else if (data == 7) {//意见反馈
        this.$router.push({ path: '/base/feedback', query: { id: item.formId } })
        // sessionStorage.setItem("dealid",item.formId)
        this.$store.state.stationStatus = false;
      } else if (data == 8) {//企业审核
        this.$router.push({ path: '/audit/companyAuditList' })
      } else if (data == 9) {//订购提醒
        this.$router.push({ path: '/clue/order'});
            sessionStorage.setItem("clueid",item.formId)
      } else if (data == 10) {//企业库认领

      } else if (data == 11) {//询单提醒 
        this.$router.push({ path: '/clue/inquiry'});
            sessionStorage.setItem("clueid",item.formId)
      } else if (data == 12) {//索样提醒
            this.$router.push({ path: '/clue/sample'});
            sessionStorage.setItem("clueid",item.formId)
      }
      this.ignore(item);
    },
    ignore(item) {
      updateReadStatus(item.id).then((res) => {
        if (res.data) {
          this.getStationMessage();
        }

      })
    },
    getBack() {
      getBackGet({ type: 1 }).then((res) => {
        this.value = res.data
      })
    },
    getStationMessage() {
      getStationMessagePage(this.queryParams).then((res) => {
        this.$store.state.stationMessage = res.data.list;
        this.$store.state.total = res.data.total
      })

    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    opennoticemange() {
      this.$store.state.stationStatus = true;
      this.getStationMessage();
    },
    logout() {
      this.$modal
        .confirm('确定注销并退出系统吗？', '提示')
        .then(() => {
          this.$store.dispatch('LogOut').then(() => {

            location.href = getPath('/index')
          })
        })
        .catch(() => { })
    }
  }
}
</script>

<style lang="scss" scoped>

.waitli_desc{
  font-size: 14px;
}
.waitbox {
  width: calc(50% - 6px);

  .waittop {
    display: flex;
    justify-content: space-between;
    padding: 0 24px;
    align-items: center;

    .waitboxtitle {
      font-weight: 700;
      font-size: 20px;
      margin-bottom: 24px;
    }

    .waitboxmore {
      font-size: 12px;
    }
  }

  .waitbottom {
    height: 432px;
    padding: 16px 24px;
    background-color: #fff;

    .waitli {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px dashed #D8D8D8;
      padding: 16px 0;

      .buttonlist {
        display: flex;
      }

      .waitli_type {
        margin-bottom: 6px;
        display: flex;
        align-items: center;

        .stitle {
          display: inline-block;
          margin-right: 5px;
          font-size: 16px;
        }
      }
    }
  }
}

.waitbox {
  width: 100%;

  .waittop {
    display: flex;
    justify-content: space-between;
    padding: 0 24px;
    align-items: center;

    .waitboxtitle {
      font-weight: 700;
      font-size: 20px;
      margin-bottom: 24px;
    }

    .waitboxmore {
      font-size: 12px;
    }
  }

  .waitbottom {
    height: 432px;
    padding: 16px 24px;
    background-color: #fff;

    .waitli {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px dashed #D8D8D8;
      padding: 16px 0;

      .buttonlist {
        display: flex;
      }

      .waitli_type {
        margin-bottom: 6px;
      }
    }
  }
}

.c-p {
  cursor: pointer;
}

.msg-text {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e0e3dd;
  padding: 10px 0;
}

.msg-top {
  display: flex;
  align-items: center;
}

.top-left {
  font-size: 18px;
  color: #000;
  font-weight: 600;
}

.top-right {
  margin-left: 10px;
  font-size: 15px;
}

.msg-content {
  line-height: 64px;
  font-size: 15px;
}

.navbar {
  height: 64px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;
  .left {
      display: flex;
      align-items: center;
      height: 64px;
      padding-left: 16px;
      .logo {
        width: 116px;
        height: 44px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .shu {
        width: 2px;
        height: 24px;
        background: rgba(0, 0, 0, 0.08);
        border-radius: 6px;
        margin-left: 12px;
        margin-right: 12px;
      }

      .welcome {
        height: 28px;
        font-family:'AlibabaPuHuiTi-Medium';
        font-size: 20px;
        color: rgba(0, 0, 0, 0.85);
        line-height: 28px;
      }
    }

  .hamburger-container {
    line-height: 64px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .topmenu-container {
    position: absolute;
    left: 50px;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    display: flex;
    //align-items: center;
    float: right;
    height: 100%;
    line-height: 64px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 35px;
          height: 35px;
          border-radius: 50%;
        }

        .user-nickname {
          margin-left: 5px;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
